// Hotel Search Form fields
export const DESTINATION_FIELD = 'locationCode';
export const CHECK_IN_FIELD = 'from';
export const CHECK_OUT_FIELD = 'to';
export const ROOMS_FIELD = 'roomsField';
export const ROOM_PARTY = 'rooms';
export const CHILDREN_AGES = 'childrenAges';
export const ADULTS_FIELD = 'adults';
export const CHILDREN_FIELD = 'children';

// Share itinerary
export const SHARE_EMAIL_FIELD = 'shareEmailField';

// Search Hotel by name
export const SEARCH_BY_FIELD = 'searchBy';

// Find order for field

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const CONFIRMATION = 'orderNumber';
